<template>
  <div ref="winner" class="winner">
   <loading :active.sync="isLoading"
        :can-cancel="false"
        loader="dots"
        color="#1f9ed3"
        :is-full-page="fullPage"></loading>
    <div class="current-info">
      <h4>Tuần số: <span class="times">{{times}}</span></h4>
      <span class="info">Mã dự thưởng của bạn:</span>
      <div class="ticket-info">{{ticketid}}</div>
    </div>
      <div v-if="ticket&&ticket.length>1" class="last-info">
        <h4>Tuần mở thưởng trước: Tuần số <span class="times">{{ticket&&ticket[1].issue||'xx'}} </span></h4>
        <span class="info">Mã dự thưởng của bạn:</span>
        <div class="ticket-info">{{ticket&&ticket[1].lottery||'xxxxxx'}}</div>
        <h4 class="info">Tình trạng giải thưởng:</h4>
        <div class="win-status">{{ticket.status===0?"Không trúng thưởng":"Không trúng thưởng"}}</div>
      </div>
      <div v-else class="last-info">
        <h4>Tuần mở thưởng trước: <span class="times">Không tham gia</span></h4>
      </div>
  </div>
</template>
<script>
import * as cookies from "js-cookie";
 // Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "winrecord",
  data() {
    return {
      ticket:'',
      winStatus:0,
      message:'',
      times:'',
      ticketid:'',
      isLoading:false,
      fullPage:true
    }
  },
  components: {
    Loading
  },
  mounted () {
    const that=this;
    this.isLoading=true;
    this.times=cookies.get('cur_issue')||'xxxx';
    this.ticketid=cookies.get('cur_ticketid')||'xxxxxxx';
    let fid=cookies.get('fid');
    let xhr=new XMLHttpRequest();
    xhr.onreadystatechange=function(){
      if(xhr.status==200&&xhr.readyState==4){
        that.isLoading=false;
        let res=JSON.parse(xhr.response);
        if(res.errcode===0){
          const {lotterys,status,message}=res;
          that.ticket=lotterys;
          that.winStatus=status;
          that.message=message;
        }else{
          that.ticket=null;
        }
      }
    }
    xhr.open('post','/query');
    xhr.setRequestHeader('Content-Type','application/json');
    xhr.send(JSON.stringify({fid:fid}));
  },
};
</script>
<style scoped>
.winner {
  position: relative;
  display: block;
  padding: 20px;
  text-align: center;
}

.current-info {
  display:block;
  position:relative;
  margin:4px 0;
}
.times{
  font-size:1.4em;
  color:red;
}
.ticket-info{
  display:block;
  width:300px;
  height:60px;
  line-height:60px;
  margin:0 auto;
  background-color:red;
  color:#fff;
  font-size:2em;
}
.info{
  display:inline-block;
  margin: 10px 0;
}

.last-info{
  display:block;
  position:relative;
  margin:20px 0;
}

.win-status{
  display:block;
  width:200px;
  margin:0 auto;
  font-size:1.2em;
  color:red;
}
</style>





// WEBPACK FOOTER //
// WinRecord.vue?4984d993